/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {findCustomers} from '../api'

export const useMutationFindCustomers = createReactQueryMutationHook('findCustomers', findCustomers)
